// FP3-097 — Shared teacher name/email helpers. ONE source for the
// Provider Service Demographics, Admin Profile tab, and the Caseload
// add-student modal so every surface derives suggestions and judges
// name↔email mismatches identically.

// Iter 33b — Derive a display name from a teacher email's local part.
// Mirrors backend `_derive_teacher_display`. Examples:
//   p.patel@lincoln.k12.us → "P Patel"
//   maria.lopez@school.edu → "Maria Lopez"
//   maria_lopez@school.org → "Maria Lopez"
export function deriveTeacherDisplay(email) {
  if (!email || !email.includes("@")) return (email || "").trim();
  const local = email.split("@", 1)[0].trim();
  if (!local) return email;
  const parts = local.replace(/_/g, ".").replace(/-/g, ".").split(".").filter(Boolean);
  if (!parts.length) return local;
  return parts.map((p) => p[0].toUpperCase() + p.slice(1)).join(" ");
}

export const TEACHER_MISMATCH_MESSAGE =
  "Teacher name and email may not match. Confirm the teacher\u2019s name and email before saving.";

const stripApostrophes = (s) => (s || "").toLowerCase().replace(/[\u2019']/g, "");

// FP3-097 — Surname ↔ email match check. Compares the FINAL surname
// token from Teacher Name against the tokens of the email LOCAL part
// (never the domain). Normalization: lowercase, apostrophes removed,
// hyphens/periods/underscores treated as separators, extra spaces
// ignored. Returns true (no warning) when either side is blank or
// unjudgeable. Supported shapes:
//   maria.lopez / m.lopez / mlopez / maria-lopez ↔ Maria Lopez
//   oconnor ↔ Sean O’Connor
//   smith-jones ↔ Avery Smith-Jones
export function teacherEmailMatches(name, email) {
  const n = (name || "").trim();
  const e = (email || "").trim();
  if (!n || !e || !e.includes("@")) return true;
  const local = stripApostrophes(e.split("@", 1)[0]);
  const localTokens = local.split(/[.\-_]+/).filter(Boolean);
  const nameTokens = stripApostrophes(n).split(/[\s.\-_]+/).filter(Boolean);
  if (!nameTokens.length || !localTokens.length) return true;
  const surname = nameTokens[nameTokens.length - 1];
  // Single-letter final tokens (initials) can't be judged fairly.
  if (surname.length < 2) return true;
  const joined = localTokens.join("");
  return (
    localTokens.some((t) => t === surname || t.endsWith(surname)) ||
    joined === surname ||
    joined.endsWith(surname)
  );
}
